import * as logoIcon from "./images/brand/logo-icon.png";
import * as logoLightGray from "./images/brand/logo-light-gray.png";
import * as logo from "./images/brand/logo.png";
import * as banquet from "./images/eventTypes/banquet.jpg";
import * as corporate from "./images/eventTypes/corporate.jpg";
import * as dance from "./images/eventTypes/dance.jpg";
import * as meeting from "./images/eventTypes/meeting.jpg";
import * as party from "./images/eventTypes/party.jpg";
import * as reception from "./images/eventTypes/reception.jpg";
import * as background from "./images/marketing/background.jpg";
import * as box63 from "./images/marketing/box63.png";
import * as cask from "./images/marketing/cask.png";
import * as crown from "./images/marketing/crown.png";
import * as sherkaan from "./images/marketing/sherkaan.png";
import * as spaces from "./images/marketing/spaces.png";
import * as options from "./images/marketing/options.png";
import * as photosandmenus from "./images/marketing/photosandmenus.png";
import * as papertrail from "./images/marketing/papertrail.png";
import * as chat from "./images/marketing/chat.png";
import * as mobileapp from "./images/marketing/mobileapp.png";
import * as instantquote from "./images/marketing/instantquote.png";
import * as livebooking from "./images/marketing/livebooking.png";
import * as payments from "./images/marketing/payments.png";
import * as claire from "./images/marketing/claire.png";
var images = {
  brand: {
    logo: logo,
    logoLightGray: logoLightGray,
    logoIcon: logoIcon
  },
  eventTypes: {
    party: party,
    dance: dance,
    meeting: meeting,
    reception: reception,
    banquet: banquet,
    corporate: corporate
  },
  marketing: {
    background: background,
    box63: box63,
    cask: cask,
    crown: crown,
    sherkaan: sherkaan,
    spaces: spaces,
    options: options,
    photosandmenus: photosandmenus,
    papertrail: papertrail,
    chat: chat,
    mobileapp: mobileapp,
    instantquote: instantquote,
    livebooking: livebooking,
    payments: payments,
    claire: claire
  }
};
export { images };
export * from "./lib";